
import React from 'react';
import {css} from 'emotion';
import {useEffect} from 'react';
import {useStateAtom} from '../../../utilities/React/UseStateAtom.js';
import {yamlParse} from '../../../utilities/yaml/yamlParse.js';
import {yamlStringify} from '../../../utilities/yaml/yamlStringify.js';

export const FormEditFormFieldCode = function (props) {

  const advancedSource = useStateAtom('');
  const advanced = useStateAtom('');

  useEffect(() => {
    if (JSON.stringify(advancedSource()) == JSON.stringify(yamlStringify(props.definitionAST())))
      return;
    advancedSource(yamlStringify(props.definitionAST()));
    advanced(yamlStringify(props.definitionAST()));
  }, [JSON.stringify(props.definitionAST())]);

  return (<>
    <div
      className={css`
        padding: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
      `}
    >
      <label
        className={css`
          display: flex;
          gap: 8px;
        `}
      >
        <div
          className={css`
            display: grid;
            place-content: start center;
            place-items: start center;
          `}
        >
          Code
        </div>
        <div
          className={css`
            display: grid;
            place-content: stretch;
            place-items: center;
            width: 100%;
            overflow: hidden;
          `}
        >
          <textarea
            className={css`
              width: 100%;
              height: 320px;
              resize: vertical;
            `}
            value={advanced()}
            onChange={(e) => {
              advanced(e.target.value);
            }}
          >{advanced()}</textarea>
        </div>
      </label>
      <div
        className={css`
          text-align: right;
        `}
        onClick={(e) => {
          props.definitionAST(yamlParse(advanced()));
        }}
      >
        <button>Update</button>
      </div>
    </div>
  </>);

};
